/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createForgotPageStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    color: '#FFFFFF',
  },
  formFooter: {
    marginTop: '10px',
    alignItems: 'center',
  },
  formTitle: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingBottom: '0.3rem',
    fontSize: '1.6rem',
    fontWeight: 500,
  },
  formGroup: {
    marginBottom: '0.2rem',
    minHeight: '66px',
    fontWeight: 500,
  },
  errorBlock: {
    marginTop: '10px',
    marginBottom: '5px',
    fontWeight: 500,
  },
  errorLine: {
    color: theme.palette.error.main,
    margin: '2px 0px',
    marginLeft: '1.8rem',
  },
}));

export { createForgotPageStyles };
